<template>
  <div class="container login">
    <div class="container__title">帐号密码登录</div>
    <Form ref="form" :rules="rules" :form.sync="form">
      <FormItem ref="account" prop="account">
        <div class="form__item__prefix">
          <img class="form__item__prefix__img" src="../../assets/img/icon-user.png" />
        </div>
        <Input v-model="form.account" placeholder="自定义账号/手机号"></Input>
      </FormItem>
      <FormItem ref="password" prop="password">
        <InputPassword v-model="form.password"></InputPassword>
      </FormItem>
      <div class="login-tools">
        <RememberMe v-model="form.save"></RememberMe>
        <router-link class="login-tools__forget" to="/forget">忘记密码？</router-link>
      </div>
      <button type="button" class="button button_primary form__submit" @click="getCaptcha" :disabled="loading">登录</button>
    </Form>
    <router-link class="login__back" to="/"><切换其他登录方式</router-link>
  </div>
</template>
<script>
import Form from '@/components/Form'
import FormItem from '@/components/FormItem'
import Input from '@/components/Input'
import InputPassword from '@/components/InputPassword'
import RememberMe from '@/components/RememberMe'
import saveMixin from '@/mixins/save'
// import { encrypt } from '@/utils/rsa'
// import PUBLICKEY from '@/constant/publicKey'
import { getSubUrl } from '@/utils/index'
import { tsmEncrypt } from '@/utils/tsm'

export default {
  components: {
    Form,
    FormItem,
    Input,
    InputPassword,
    RememberMe
  },
  mixins: [ saveMixin ],
  mounted() {
    // console.log(getSubUrl())
  },
  data() {
    const storage = window.localStorage.getItem('sc_account')
    return {
      form: {
        account: storage,
        password: '',
        save: Boolean(storage)
      },
      rules: {
        account: [
          { type: 'require', message: '请输入用户账号' },
          { type: 'regex', pattern: /^[0-9a-zA-Z_-]{6,20}$/, message: '请输入正确的自定义帐号或手机号码' }
        ],
        password: [
          { type: 'require', message: '请输入密码' }
        ]
      },
      loading: false
    }
  },
  methods: {
    async submitHandler(captchaRes) {
      this.extraError = null
      const flag = this.$refs.form.validate()
      if (!flag) {
        return false
      }
      this.loading = true
      // 用公钥加密密码。
      // const encryptedPassword = encrypt(PUBLICKEY, this.form.password)
      // tsm加密
      const tsmEncryptedPassword = await tsmEncrypt(this.form.password)
      // 记住账号（登录前调用，避免登录后直接跳转跳过记住帐号逻辑）
      this.save('sc_account', this.form.account)
      // 登录及错误处理
      const { status, data } = await this.$post(this.$CGI.login.login, {
        account: this.form.account,
        // encrypted: encryptedPassword,
        tsmEncrypted: tsmEncryptedPassword,
        ticket: captchaRes.ticket,
        randstr: captchaRes.randstr,
        suburl: getSubUrl()
      }, false)
      if (status === 200) {
        // this.dispatch('App', 'showSuccess', data)
        location.href = getSubUrl()
      } else {
        if (data.type && this.$refs[data.type]) {
          this.$refs[data.type].setError({ message: data.msg })
        } else {
          this.$Message.error(data.msg || data)
          // this.dispatch('App', 'showError', data.msg || data)
        }
      }
      this.loading = false
    },
    // 登录按钮加入防水墙
    async getCaptcha(res) {
      /* eslint-disable no-new */
      try {
        const tcCaptcha = new window.TencentCaptcha(
          '2089780657',
          async (captchaRes) => {
            if (!captchaRes.ticket) {
              return
            }
            // 进行帐号登录
            await this.submitHandler(captchaRes)
          }
        )
        tcCaptcha.show()
      } catch (e) {
        this.$Message.error('防水墙组件错误，暂时无法获取验证码，请联系系统管理员')
        // this.$refs.message.error('防水墙组件错误，暂时无法获取验证码')
      }
    }
  }
}
</script>
